const React = require("react");
function IconPlay(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: props.fill || "#232323",
    height: props.size || 24,
    size: props.size || 24,
    width: props.size || 24
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5 18.6235V4.37652c0-.39002.13827-.71694.41481-.98077C5.69136 3.13192 6.01399 3 6.38272 3c.11522 0 .23621.01721.36296.05162s.24774.08603.36296.15486L18.3778 10.33c.2074.1376.3629.3097.4666.5162.1037.2064.1556.4244.1556.6538s-.0519.4474-.1556.6538c-.1037.2065-.2592.3786-.4666.5162L7.10864 19.7935c-.11522.0688-.23621.1205-.36296.1549S6.49794 20 6.38272 20c-.36873 0-.69136-.1319-.96791-.3958Q5 19.2085 5 18.6235"
  }));
}
module.exports = IconPlay;